import * as React from 'react';
import { createElement } from 'react';
import { Slider } from '@alifd/next';
import { articleListAuthorityPage } from '../../http/api';
import baseURL from '../../http/url';
import './index.scss';
export default class ArticleSlider extends React.PureComponent {
    state;
    props;
    setState;
    constructor(props) {
        super(props);
        this.state = {
            dataArr: [],
            type: "",
            style: {},
            dotsRender: {
                dotsRender: (index) => {
                    return createElement("a", null, index);
                }
            }
        };
    }
    componentDidMount() {
        this.articleListAuthorityPageRequest(this.props);
    }
    articleListAuthorityPageRequest = (nextProps) => {
        const params = {
            articleTypeIds: nextProps.articleArr,
            pageSize: nextProps.number,
            pageNum: 1
        };
        articleListAuthorityPage(params).then(({ resultCode, data }) => {
            if (resultCode === 200) {
                this.setState({
                    dataArr: data.list.map(item => {
                        return {
                            imgUrl: `${baseURL.url}/image/${item.articleImgUrl}` || '',
                            articleTitle: item.articleTitle,
                            articleId: item.articleId
                        };
                    }),
                });
            }
        });
    };
    componentWillReceiveProps(nextProps) {
        if (this.props.type === nextProps.type) {
            if (nextProps.type === 'none')
                this.setState({ dotsRender: {} });
            else
                this.setState({
                    dotsRender: {
                        dotsRender: (index) => {
                            return createElement("a", null, index);
                        }
                    }
                });
        }
        if (this.props.number !== nextProps.number) {
            if (nextProps.articleArr.length) {
                this.articleListAuthorityPageRequest(nextProps);
            }
        }
        if (this.props.articleArr.length !== nextProps.articleArr.length) {
            this.articleListAuthorityPageRequest(nextProps);
        }
    }
    render() {
        return (createElement("div", { className: "article-slider", style: { width: `${this.props.width}%`, ...this.props.style, height: 'auto', } },
            createElement(Slider, { slidesToShow: this.props.limit, autoplay: true, autoplaySpeed: 4000, dotsClass: this.props.type, ...this.state.dotsRender }, this.state.dataArr.map((item, index) => (createElement("div", { key: index, className: "slider-img-wrapper", style: { height: this.props.style.height || "300px" } },
                createElement("img", { src: item.imgUrl, alt: item.articleTitle, style: { height: this.props.isTitle ? "calc(100% - 50px)" : "100%" } }),
                this.props.isTitle && createElement("div", { className: "slider-tittle" }, item.articleTitle)))))));
    }
}
;
